export default __webpack_public_path__ + "static/media/pic8.a3608cbe.jpg";